/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {LocalListComponent} from "./local-list/local-list.component";
import {editRoute, newRoute} from "../../shared/services/data.service";
import {LocalFormComponent} from "./local-form/local-form.component";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class LocaisRoutingModule {}


export const locaisRoutes: any[] = [
  {
    path: '',
    component: LocalListComponent
  },{
    path: editRoute + '/:id',
    component: LocalFormComponent
  },{
    path: newRoute,
    component: LocalFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/locais-routing.module.ts
 **/